/* eslint-disable */
import { createFilterOptions } from '@mui/material/Autocomplete';
import {
  coordination,
  project,
  useCreateProjectContactMutation,
  useCreateProjectMutation,
  useCreateProjectTeamMutation,
  useCreateRoleMutation,
  useDeleteProjectContactMutation,
  useDeleteProjectTeamMutation,
  useGetContactsQuery,
  useGetMarketSegmentsQuery,
  useGetOrganizationsQuery,
  useGetProjectContactsQuery,
  useGetProjectStagesQuery,
  useGetProjectTeamsQuery,
  useGetProjectTemplatesQuery,
  useGetProjectTypesQuery,
  useGetRolesQuery,
  useGetSubscribersQuery,
  useGetSubscriptionContactsQuery,
  useGetTeamsQuery,
  useUpdateProjectContactMutation,
  useUpdateProjectTeamMutation,
} from 'store/api';
import {
  Attachment,
  Contact,
  Organization,
  Project,
  ProjectContact,
  ROLETYPE,
  Role,
  Subscriber,
  SubscriptionContact,
  Team,
  MarketSegment,
} from 'store/api/models';
import { JItem } from '@centerpiece/components';
import { FormikHelpers, getIn } from 'formik';
import { statesConfig, sortString } from '@centerpiece/components';
import * as Yup from 'yup';
import {
  Box,
  Chip,
  IconButton,
  InputAdornment,
  InputBaseComponentProps,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  InfoOutlined,
  RestartAlt,
  Person,
  AccountBox,
  PersonAdd,
  Add,
  CorporateFare,
  Mail,
  Badge,
  KeyboardReturn,
  Contacts,
  FolderShared,
} from '@mui/icons-material';
import { useState } from 'react';
import {
  groupOrganizationContacts,
  stakeHolderOptions,
} from 'utils/contacts.utils';
import {
  useStakeholderForm,
  useInternalRolesForm,
  customStakeholder,
  variableRoleStakeholder,
} from './useStakeholderForm';
import { useAddress } from './jfield/useAddress';
import { Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomPopper = styled(Popper)(({ theme }) => ({
  // Set a larger width for the options list
  '& .MuiAutocomplete-paper': {
    minWidth: '40vw',
    width: '600px', // Set your desired width here
    maxWidth: '90vw',
  },
}));

export const useFESProjectForm = ({
  id,
  edit = false,
  setPreview,
  setOpenContact,
}: {
  id?: number;
  edit?: boolean;
  setPreview?: Function;
  setOpenContact: Function;
}): [any, JItem[]] => {
  const stakeholderForm = useStakeholderForm(setOpenContact);
  const internalRolesForm = useInternalRolesForm(setOpenContact);
  const { data: templates = [] } = useGetProjectTemplatesQuery({});
  // const { data: stages = [] } = useGetProjectStagesQuery({})
  const { data: types = [] } = useGetProjectTypesQuery({});
  const { data: teams = [] } = useGetTeamsQuery({});
  const { data: project_teams = [], refetch: refetchProjectTeams } =
    useGetProjectTeamsQuery({ params: { project: id, nested: 'all' } });
  const { data: project_contacts = [], refetch: refetchProjectContacts } =
    useGetProjectContactsQuery({ params: { project: id, nested: 'all' } });
  const [loading, setLoading] = useState<boolean>(false);
  const { data: market_segments = [] } = useGetMarketSegmentsQuery({});
  const { data: roles = [] } = useGetRolesQuery({});
  const [createRole] = useCreateRoleMutation();
  const { data: subscribers = [] } = useGetSubscribersQuery({
    params: { nested: 'all' },
  });
  const { data: subscription_contacts = [] } = useGetSubscriptionContactsQuery({
    params: { nested: 'all' },
  });
  const { data: organizations = [] } = useGetOrganizationsQuery({
    params: { nested: 'all' },
  });
  const [deleteProjectTeam] = useDeleteProjectTeamMutation();
  const [createProjectTeam] = useCreateProjectTeamMutation();
  const [editProjectTeam] = useUpdateProjectTeamMutation();
  const [deleteProjectContact] = useDeleteProjectContactMutation();
  const [createProjectContact] = useCreateProjectContactMutation();
  const [editProjectContact] = useUpdateProjectContactMutation();
  const projectAddress = useAddress({ name: 'form' });
  return [
    Yup.object({
      title: Yup.string().required('Project name is required'),
      type: Yup.object().nullable().required('Project type is required'),
      template: !edit
        ? Yup.object()
            .required('Please select a template or specify "No Template"')
            .nullable()
        : Yup.object().nullable(),
      // type: Yup.object().required('Please select a project type').nullable(),
      // contacts: Yup.array().of(
      //   Yup.object()
      //     .shape({
      //       contact: Yup.object()
      //         .nullable()
      //         .required('Please select a contact'),
      //     })
      //     .nullable()
      // ),
      stakeholders: Yup.array().of(
        Yup.object()
          .shape({
            stakeholdertype: Yup.object()
              .nullable()
              .required('Please select a type'),
          })
          .nullable()
      ),
    }),
    [
      {
        precondition: () => !edit,
        name: 'project-templates',
        label: 'Project Template',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'project-templates-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'template',
        label: 'Project Template *',
        itemType: 'autocomplete',
        options: [
          ...(templates || []),
          { id: -1, title: 'No Template' } as any,
        ],
        gridProps: (values: any) =>
          !edit && !!values?.template && !(values?.template?.id === -1)
            ? { xs: 12, sm: 6 }
            : { xs: 12 },
        jItemProps: {
          size: 'small',
          helperText: (values: any) => {
            if (values?.id !== -1) {
              return (
                <Typography variant="caption" id="tableTitle" component="div">
                  <Tooltip title={`Preview Template`}>
                    <IconButton
                      onClick={event => {
                        // event.stopPropagation()
                        // event.preventDefault()
                        setPreview && setPreview(values.id);
                      }}
                      size="small"
                    >
                      <InfoOutlined color="secondary" />
                    </IconButton>
                  </Tooltip>{' '}
                  Preview Template
                </Typography>
              );
            } else {
              return <div />;
            }
          },
          onChange: (value: any, name: string, setFieldValue: Function) => {
            setFieldValue(
              'type',
              value?.type_r ? types.find(t => t.id === value?.type_r?.id) : null
            );
          },
        },
      },
      // {
      //   precondition: (values: any) =>
      //     !edit && !!values?.template && !(values?.template?.id === -1),
      //   name: 'stage',
      //   label: 'Starting Stage (optional)',
      //   itemType: 'autocomplete',
      //   options: values =>
      //     [...values?.template?.stages].sort((a, b) => a.sequence - b.sequence),
      //   gridProps: { xs: 12, sm: 6 },
      // },
      {
        precondition: (values: any) =>
          !edit && !!values?.template && !(values?.template?.id === -1),
        name: 'assignees',
        multiple: true,
        label: 'Assign all template items (optional)',
        itemType: 'autocomplete',
        options: values => {
          return subscribers
            ?.filter(
              (s: Subscriber) =>
                !values?.assignees?.find((r: any) => s.contact_r?.id === r.id)
            )
            ?.map((subscriber: Subscriber) => ({
              id: subscriber?.contact_r.id,
              email: subscriber?.contact_r?.email,
              name: subscriber?.contact_r?.firstname
                ? `${subscriber?.contact_r?.firstname} ${subscriber?.contact_r?.lastname}`
                : subscriber?.contact_r?.email,
            }));
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        precondition: () => !edit,
        name: 'internal-team-label',
        label: 'Project Team',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'internal-team-label-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'contacts',
        itemType: 'fieldarray',
        label: 'teammates',
        array: [
          {
            name: 'contact',
            label: 'Teammate',
            // freeSolo: true,
            itemType: 'autocomplete',
            jItemProps: {
              renderOption: (props: any, option: any) => {
                return (
                  <Box component="li" {...props}>
                    <small>
                      <AccountBox
                        fontSize="inherit"
                        sx={{ mr: 1 }}
                        color="secondary"
                      />
                    </small>
                    {option.name}
                  </Box>
                );
              },
              getOptionLabel: (option: any) =>
                `${option?.firstname} ${option?.lastname}`,
            },
            options: values => {
              return subscribers
                ?.filter(
                  (s: Subscriber) =>
                    !values?.contacts?.find(
                      (r: any) => s.contact_r?.id === r.contact?.id
                    )
                )
                ?.map((subscriber: Subscriber) => {
                  // const job_title = subscriber?.contact_r?.form?.custom_fields?.find((cf:any) => cf.job_title !== '')
                  return {
                    ...subscriber.contact_r,
                    // id: subscriber?.contact_r.id,
                    // email: subscriber?.contact_r?.email,
                    name: subscriber?.contact_r?.firstname
                      ? `${subscriber?.contact_r?.firstname} ${subscriber?.contact_r?.lastname}`
                      : // ? `${subscriber?.contact_r?.firstname} ${subscriber?.contact_r?.lastname}${job_title ? ` - ${job_title}`:''}${subscriber?.contact_r?.email ? ` - ${subscriber?.contact_r?.email}`:''}`
                        subscriber?.contact_r?.email,
                  };
                });
            },
            gridProps: { xs: 12, sm: 5 },
          },
          {
            name: 'role',
            label: 'Role',
            itemType: 'autocomplete',
            // freeSolo: true,
            options: [
              ...(roles.filter(role => role.type === 'Internal') || []),
            ].sort((a, b) => sortString(a.name, b.name)),
            jItemProps: {
              getOptionLabel: (option: any) => option?.name || `Role`,
            },
            gridProps: { xs: 10, sm: 5 },
          },
          {
            name: 'form.watcher',
            label: 'Notifications',
            itemType: 'checkbox',
            jItemProps: {
              tooltip:
                'User will receive email notifications on item and project completions.',
              // sx: {
              //   boxSizing: 'border-box',
              //   px: { xs: 0.5 },
              // },
              // padding: 'none',
              // size: 'small',
            },
            gridProps: { xs: 1, sm: 2 },
          },
        ],
        gridProps: { xs: 12 },
      },
      {
        name: 'project-details',
        label: 'Project Details',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-details-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'title',
        label: 'Project Name *',
        itemType: 'textfield',
        gridProps: { xs: 12 },
        jItemProps: {
          size: 'small',
          // InputProps: { size: 'small' },
        },
      },
      // {
      //   name: 'stage',
      //   label: 'Project Stage',
      //   itemType: 'autocomplete',
      //   options: stages,
      //   gridProps: { xs: 12, sm: 6 },
      // },
      {
        name: 'details',
        label: 'Project Description',
        itemType: 'textfield',
        jItemProps: { multiline: true, rows: 4, variant: 'outlined' },
        gridProps: { xs: 12 },
      },
      {
        // precondition: () => !edit,
        name: 'type',
        label: 'Project Type *',
        itemType: 'autocomplete',
        options: types,
        gridProps: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0
            ? { xs: 12, sm: 4 }
            : { xs: 12, sm: 6 },
        jItemProps: {
          onChange: (value: any, name: string, setFieldValue: Function) => {
            setFieldValue('market_segment', null);
          },
        },
      },
      {
        precondition: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0,
        name: 'market_segment',
        label: 'Market Segment',
        // disabled: edit,
        itemType: 'autocomplete',
        options: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ),
        gridProps: { xs: 12, sm: 4 },
      },
      {
        precondition: () => !edit,
        name: 'teams',
        multiple: true,
        label: 'Team',
        itemType: 'autocomplete',
        options: values => {
          return (
            teams?.filter(
              (t: Team) => !values?.teams?.find((r: any) => t.id === r.id)
            ) || []
          );
        },
        gridProps: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0
            ? { xs: 12, sm: 4 }
            : { xs: 12, sm: 6 },
      },
      {
        precondition: () => edit,
        name: 'teams',
        itemType: 'autocomplete',
        options: (values: any) => {
          return (
            teams?.filter(
              (t: Team) => !values?.find((tr: any) => t.id === tr?.team_r?.id)
            ) || []
          );
        },
        multiple: true,
        label: 'Team',
        loading: loading,
        gridProps: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0
            ? { xs: 12, sm: 4 }
            : { xs: 12, sm: 6 },
        value:
          project_teams?.map(pt => ({ ...pt, name: pt?.team_r?.name })) || [],
        jItemProps: {
          disableClearable: true,
          onChange: async (items: any[]) => {
            if (items && Array.isArray(items) && items.length > 0) {
              items.forEach(async (item: any) => {
                if (!item.team) {
                  setLoading(true);
                  await createProjectTeam({ project: id, team: item.id });
                  refetchProjectTeams();
                  // props?.afterSave && props?.afterSave()
                  setLoading(false);
                }
              });
            }
          },
          renderTags: (value: readonly string[], getTagProps: any) => {
            return value.map((option: any, index: number) => (
              <Chip
                variant="outlined"
                color="secondary"
                label={typeof option === 'string' ? option : option?.name}
                size="small"
                {...getTagProps({ index })}
                onDelete={async props => {
                  setLoading(true);
                  if (option.id) {
                    await deleteProjectTeam(option.id);
                    getTagProps({ index }).onDelete(props);
                    refetchProjectTeams();
                    // props?.afterSave && props?.afterSave()
                  }
                  setLoading(false);
                }}
              />
            ));
          },
        },
      },

      {
        name: 'job-location-label',
        label: 'Job Location',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'job-location-label-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      ...projectAddress,
      // {
      //   name: 'form.address',
      //   itemType: 'textfield',
      //   label: 'Address',
      //   gridProps: { xs: 12 },
      // },
      // {
      //   name: 'form.city',
      //   itemType: 'textfield',
      //   label: 'City',
      //   gridProps: { xs: 12, sm: 3 },
      // },
      // {
      //   name: 'form.state',
      //   label: 'State',
      //   itemType: 'autocomplete',
      //   options: Object.keys(statesConfig),
      //   gridProps: { xs: 12, sm: 3 },
      // },
      // {
      //   name: 'form.zipcode',
      //   itemType: 'textfield',
      //   label: 'Postal Code',
      //   gridProps: { xs: 12, sm: 3 },
      // },
      // {
      //   name: 'form.country',
      //   itemType: 'autocomplete',
      //   options: ['USA', 'CA'],
      //   label: 'Country',
      //   gridProps: { xs: 12, sm: 3 },
      // },
      {
        name: 'project-dates',
        label: 'Project Dates',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-dates-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      // {
      //   name: 'form.response_date',
      //   label: 'Response due',
      //   itemType: 'datepicker',
      //   gridProps: { xs: 12, sm: 6 },
      // },
      {
        name: 'due_date',
        label: 'Expected completion date',
        itemType: 'datepicker',
        gridProps: { xs: 12, sm: 6 },
      },
      {
        name: 'project-financials',
        label: 'Project Financials',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-financials-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        name: 'form.revenue',
        label: 'Estimated Revenue',
        itemType: 'textfield',
        // helpertext: "Add prices in $",
        jItemProps: {
          type: 'formatted_number',
          // type: 'number',
          InputProps: {
            startAdornment: '$',
          },
          inputProps: {
            inputMode: 'numeric',
          },
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        name: 'form.margin',
        label: 'Estimated Margin',
        itemType: 'textfield',
        // input_type: 'number',
        // helpertext: "Add win rate in %",
        jItemProps: {
          type: 'number',
          InputProps: {
            startAdornment: '%',
          },
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        precondition: () => edit,
        name: 'form.realized_revenue',
        label: 'Realized Revenue',
        itemType: 'textfield',
        // helpertext: "Add prices in $",
        jItemProps: {
          type: 'formatted_number',
          // type: 'number',
          InputProps: {
            startAdornment: '$',
          },
          inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*', // Only allow numeric input
          },
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        precondition: () => edit,
        name: 'form.realized_margin',
        label: 'Realized Margin',
        itemType: 'textfield',
        // input_type: 'number',
        // helpertext: "Add win rate in %",
        jItemProps: {
          type: 'number',
          InputProps: {
            startAdornment: '%',
          },
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        precondition: () => !edit,
        name: 'attachments-label',
        label: 'Attachments',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'attachments-label-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'attachments',
        label: 'Upload Project Documents',
        itemType: 'dropzone',
        gridProps: { xs: 12 },
      },
      {
        name: 'custom-fields',
        itemType: 'typography',
        jItemProps: {
          variant: 'overline',
          sx: { mb: '0 !important', pb: '0 !important' },
        },
        label: 'Additional Fields',
      },
      {
        name: 'additional-fields-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        // precondition: (values: any) => !disable_type && values?.type === 'Default',
        name: 'form.custom_fields',
        itemType: 'fieldarray',
        label: 'Additional Field',
        gridProps: {
          // sx: { paddingTop: '10px !important' },
        },
        array: [
          {
            precondition: (values: any) =>
              !values?.form?.custom_fields?.[values.index]?.fieldtype,
            name: 'fieldtype',
            label: 'Type',
            // disabled: edit,
            jItemProps: edit ? { type: 'local-disabled' } : {},
            itemType: 'autocomplete',
            options: ['Owner', 'Custom'],
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Custom',
            name: 'dynamic',
            label: 'Custom Field',
            ...(!edit
              ? {
                  tooltip: {
                    title: (
                      <Typography variant="body1">
                        Please specify the title of the field
                      </Typography>
                    ),
                    open: true,
                    placement: 'top',
                    arrow: true,
                  },
                }
              : {}),
            jItemProps: {
              textFieldType: 'custom',
              // labelFunc: (name: any, values: any, formik: FormikHelpers<any>) => {
              //   return getIn(values, name) || 'Please enter the field label...'
              // },
              InputProps: {
                startAdornment: (
                  name: any,
                  values: any,
                  formik: FormikHelpers<any>
                ) => {
                  if (!getIn(values, name)?.value) {
                    return (
                      <InputAdornment position="end">
                        <Tooltip title={`Reset type`}>
                          <IconButton
                            onClick={() => {
                              formik.setFieldValue(name, undefined);
                              formik.setFieldValue(
                                name.replaceAll('dynamic', 'fieldtype'),
                                undefined
                              );
                            }}
                          >
                            <RestartAlt color="secondary" />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    );
                  }
                },
              },
            },
            itemType: 'textfield',
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Owner',
            name: 'owner_name',
            label: 'Owner',
            itemType: 'textfield',
          },
          // {
          //   precondition: (values: any) => values?.form?.custom_fields?.[values.index]?.fieldtype === "Custom",
          //   name: 'value',
          //   label: 'Value',
          //   itemType: 'textfield',
          // },
          // {
          //   precondition: (values: any) => values?.form?.custom_fields?.[values.index]?.fieldtype === "Team",
          //   name: 'team',
          //   label: 'Select a Team',
          //   // disabled: edit,
          //   jItemProps: edit ? { type: 'local-disabled' } : {
          //     InputProps: {
          //       startAdornment: (name: any, values: any, formik: FormikHelpers<any>) => {
          //         return (
          //           <Tooltip title={`Reset type`}>
          //             <IconButton
          //               onClick={() => formik.setFieldValue(name.replaceAll('team', 'fieldtype'), undefined)}
          //             >
          //               <RestartAlt color='secondary' />
          //             </IconButton>
          //           </Tooltip>
          //         )
          //       },
          //     },
          //   },
          //   itemType: 'autocomplete',
          //   options: teams,
          // },
          // {
          //   precondition: (values: any) =>
          //     values?.form?.custom_fields?.[values.index]?.fieldtype ===
          //     'Market Segment',
          //   name: 'market_segment',
          //   label: 'Market Segment',
          //   // disabled: edit,
          //   jItemProps: {
          //     type: edit ? 'local-disabled' : undefined,
          //     InputProps: {
          //       startAdornment: (
          //         name: any,
          //         values: any,
          //         formik: FormikHelpers<any>
          //       ) => {
          //         if (!getIn(values, name)) {
          //           return (
          //             <Tooltip title={`Reset type`}>
          //               <IconButton
          //                 onClick={() =>
          //                   formik.setFieldValue(
          //                     name.replaceAll('market_segment', 'fieldtype'),
          //                     undefined
          //                   )
          //                 }
          //               >
          //                 <RestartAlt color="secondary" />
          //               </IconButton>
          //             </Tooltip>
          //           );
          //         }
          //       },
          //     },
          //   },
          //   itemType: 'autocomplete',
          //   options: market_segments,
          // },
        ],
      },
      // {
      //   // precondition: (values: any) => disable_type,
      //   name: 'form.custom_fields',
      //   itemType: 'jItem',
      //   label: '',
      //   gridProps: {
      //     sx: { paddingTop: '10px !important' },
      //   },
      // },
      // { ...internalRolesForm, precondition: (values: any) => !edit },
      {
        precondition: (values: any) => !edit,
        name: 'stakeholder-fields',
        itemType: 'typography',
        jItemProps: {
          variant: 'overline',
          sx: { mb: '0 !important', pb: '0 !important' },
        },
        label: 'Project Stakeholders',
      },
      {
        precondition: (values: any) => !edit,
        name: 'stakeholder-fields-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: (values: any) => !edit,
        name: 'stakeholders',
        itemType: 'fieldarray',
        label: '',
        // device: downMd ? 'mobile' : 'desktop',
        jItemProps: {
          addLabel: 'Add other project stakeholders',
        },
        array: [
          {
            precondition: (values: any) =>
              !values?.stakeholders?.[values.index]?.stakeholdertype,
            name: 'stakeholdertype',
            label: 'Type',
            itemType: 'autocomplete',
            options: [
              ...roles?.filter(r => r.type === 'External'),
              // { id: -1, name: 'Custom' },
            ],
            gridProps: { xs: 10, sm: 5 },
          },
          ...(roles
            ?.filter(r => r.type === 'External')
            .map(
              role =>
                variableRoleStakeholder(
                  role,
                  stakeHolderOptions({
                    subscription_contacts,
                    organizations,
                    role,
                  }),
                  setOpenContact,
                  undefined,
                  { gridProps: { xs: 10, sm: 5 } },
                  { PopperComponent: CustomPopper }
                ) as JItem
            ) || []),
          customStakeholder(
            stakeHolderOptions({
              subscription_contacts,
              organizations,
            }),
            setOpenContact,
            undefined,
            { gridProps: { xs: 10, sm: 5 } },
            { PopperComponent: CustomPopper }
          ) as JItem,
          {
            name: 'form.watcher',
            label: 'Notifications',
            itemType: 'checkbox',
            jItemProps: {
              tooltip:
                'User will receive email notifications on item and project completions.',
              sx: {
                boxSizing: 'border-box',
                px: { xs: 0.5 },
              },
              padding: 'none',
              size: 'small',
            },
            gridProps: { xs: 1, sm: 1 },
          },
        ],
      },
      // {
      //   ...stakeholderForm,
      //   array: stakeholderForm.array
      //     ? [
      //         // ...stakeholderForm.array,
      //         { ...stakeholderForm.array[0], gridProps: { xs: 10, sm: 5 } },
      //         { ...stakeholderForm.array[1], gridProps: { xs: 10, sm: 5 } },
      //         {
      //           name: 'form.watcher',
      //           label: 'Notifications',
      //           itemType: 'checkbox',
      //           jItemProps: {
      //             tooltip:
      //               'User will receive email notifications on item and project completions.',
      //             sx: {
      //               boxSizing: 'border-box',
      //               px: { xs: 0.5 },
      //             },
      //             padding: 'none',
      //             size: 'small',
      //           },
      //           gridProps: { xs: 1, sm: 1 },
      //         },
      //       ]
      //     : undefined,
      //   precondition: (values: any) => !edit,
      // },
      {
        precondition: () => !edit,
        name: 'submit',
        itemType: 'button',
        jItemProps: { type: 'submit' },
        label: 'CREATE PROJECT',
        gridProps: { xs: 12, sm: 6, md: 5, mx: 'auto' },
      },
    ],
  ];
};

export const useFESEditProjectForm = ({
  id,
  setPreview,
  setOpenContact,
}: {
  id?: number;
  setPreview?: Function;
  setOpenContact: Function;
}): [any, JItem[]] => {
  const { data: types = [] } = useGetProjectTypesQuery({});
  const { data: teams = [] } = useGetTeamsQuery({});
  const { data: project_teams = [], refetch: refetchProjectTeams } =
    useGetProjectTeamsQuery({ params: { project: id, nested: 'all' } });
  const { data: project_contacts = [], refetch: refetchProjectContacts } =
    useGetProjectContactsQuery({ params: { project: id, nested: 'all' } });
  const [loading, setLoading] = useState<boolean>(false);
  const { data: market_segments = [] } = useGetMarketSegmentsQuery({});
  const [createRole] = useCreateRoleMutation();
  const [deleteProjectTeam] = useDeleteProjectTeamMutation();
  const [createProjectTeam] = useCreateProjectTeamMutation();
  const [editProjectTeam] = useUpdateProjectTeamMutation();
  const [deleteProjectContact] = useDeleteProjectContactMutation();
  const [createProjectContact] = useCreateProjectContactMutation();
  const [editProjectContact] = useUpdateProjectContactMutation();
  const projectAddress = useAddress({ name: 'form' });
  return [
    Yup.object({
      title: Yup.string().required('Project name is required'),
      type: Yup.object().nullable().required('Project type is required'),
      template: Yup.object().nullable(),
      // type: Yup.object().required('Please select a project type').nullable(),
      contacts: Yup.array().of(
        Yup.object()
          .shape({
            contact: Yup.object()
              .nullable()
              .required('Please select a contact'),
          })
          .nullable()
      ),
      stakeholders: Yup.array().of(
        Yup.object()
          .shape({
            stakeholdertype: Yup.object()
              .nullable()
              .required('Please select a type'),
          })
          .nullable()
      ),
    }),
    [
      {
        name: '',
        label: '',
        itemType: 'paper',
        jItemProps: { paper: { sx: { py: 0, px: 0 }, elevation: 0 } },
        gridProps: { xs: 12 },
        array: [
          {
            name: 'project-details',
            label: 'Project Details',
            itemType: 'typography',
            jItemProps: { variant: 'overline' },
          },
          {
            name: 'project-details-bottom',
            label: '',
            itemType: 'divider',
            gridProps: { sx: { paddingTop: '0px !important' } },
          },
          {
            name: '',
            label: '',
            itemType: 'paper',
            jItemProps: { paper: { sx: { py: 0, px: 0 }, elevation: 0 } },
            gridProps: { xs: 12, lg: 6 },
            array: [
              {
                name: 'details',
                label: 'Project Description',
                itemType: 'textfield',
                jItemProps: { multiline: true, rows: 3, variant: 'outlined' },
                gridProps: { xs: 12 },
              },
            ],
          },
          {
            name: '',
            label: '',
            itemType: 'paper',
            jItemProps: { paper: { sx: { py: 0, px: 0 }, elevation: 0 } },
            gridProps: { xs: 12, lg: 6 },
            array: [
              {
                name: 'due_date',
                label: 'Expected completion date',
                itemType: 'datepicker',
                gridProps: { xs: 12, sm: 6 },
              },
              {
                name: 'teams',
                itemType: 'autocomplete',
                options: (values: any) => {
                  return (
                    teams?.filter(
                      (t: Team) =>
                        !values?.find((tr: any) => t.id === tr?.team_r?.id)
                    ) || []
                  );
                },
                multiple: true,
                label: 'Team',
                loading: loading,
                gridProps: { xs: 12, sm: 6 },
                value:
                  project_teams?.map(pt => ({
                    ...pt,
                    name: pt?.team_r?.name,
                  })) || [],
                jItemProps: {
                  disableClearable: true,
                  onChange: async (items: any[]) => {
                    if (items && Array.isArray(items) && items.length > 0) {
                      items.forEach(async (item: any) => {
                        if (!item.team) {
                          setLoading(true);
                          await createProjectTeam({
                            project: id,
                            team: item.id,
                          });
                          refetchProjectTeams();
                          // props?.afterSave && props?.afterSave()
                          setLoading(false);
                        }
                      });
                    }
                  },
                  renderTags: (value: readonly string[], getTagProps: any) => {
                    return value.map((option: any, index: number) => (
                      <Chip
                        variant="outlined"
                        color="secondary"
                        label={
                          typeof option === 'string' ? option : option?.name
                        }
                        size="small"
                        {...getTagProps({ index })}
                        onDelete={async props => {
                          setLoading(true);
                          if (option.id) {
                            await deleteProjectTeam(option.id);
                            getTagProps({ index }).onDelete(props);
                            refetchProjectTeams();
                            // props?.afterSave && props?.afterSave()
                          }
                          setLoading(false);
                        }}
                      />
                    ));
                  },
                },
              },
              {
                name: 'type',
                label: 'Project Type *',
                itemType: 'autocomplete',
                options: types,
                gridProps: (values: any) =>
                  values?.type?.id &&
                  market_segments?.filter(
                    (ms: MarketSegment) => ms?.project_type === values?.type?.id
                  ).length > 0
                    ? { xs: 12, sm: 6 }
                    : { xs: 12 },
                jItemProps: {
                  onChange: (
                    value: any,
                    name: string,
                    setFieldValue: Function
                  ) => {
                    setFieldValue('market_segment', null);
                  },
                },
              },
              {
                precondition: (values: any) =>
                  values?.type?.id &&
                  market_segments?.filter(
                    (ms: MarketSegment) => ms?.project_type === values?.type?.id
                  ).length > 0,
                name: 'market_segment',
                label: 'Market Segment',
                // disabled: edit,
                itemType: 'autocomplete',
                options: (values: any) =>
                  market_segments?.filter(
                    (ms: MarketSegment) => ms?.project_type === values?.type?.id
                  ),
                gridProps: { xs: 12, sm: 6 },
              },
            ],
          },
        ],
      },
      {
        name: '',
        label: '',
        itemType: 'paper',
        jItemProps: { paper: { sx: { py: 0, px: 0 }, elevation: 0 } },
        gridProps: { xs: 12, lg: 6 },
        array: projectAddress,
      },
      {
        name: '',
        label: '',
        itemType: 'paper',
        jItemProps: { paper: { sx: { py: 0, px: 0 }, elevation: 0 } },
        gridProps: { xs: 12, lg: 6 },
        array: [
          {
            name: 'project-financials',
            label: 'Project Financials',
            itemType: 'typography',
            jItemProps: { variant: 'overline' },
          },
          {
            name: 'project-financials-bottom',
            label: '',
            itemType: 'divider',
            gridProps: { sx: { paddingTop: '0px !important' } },
          },
          {
            name: 'form.revenue',
            label: 'Estimated Revenue',
            itemType: 'textfield',
            // helpertext: "Add prices in $",
            jItemProps: {
              type: 'formatted_number',
              // type: 'number',
              InputProps: {
                startAdornment: '$',
              },
              inputProps: {
                inputMode: 'numeric',
              },
            },
            gridProps: { xs: 12, sm: 6 },
          },
          {
            name: 'form.margin',
            label: 'Estimated Margin',
            itemType: 'textfield',
            // input_type: 'number',
            // helpertext: "Add win rate in %",
            jItemProps: {
              type: 'number',
              InputProps: {
                startAdornment: '%',
              },
            },
            gridProps: { xs: 12, sm: 6 },
          },
          {
            name: 'form.realized_revenue',
            label: 'Realized Revenue',
            itemType: 'textfield',
            // helpertext: "Add prices in $",
            jItemProps: {
              type: 'formatted_number',
              // type: 'number',
              InputProps: {
                startAdornment: '$',
              },
              inputProps: {
                inputMode: 'numeric',
                pattern: '[0-9]*', // Only allow numeric input
              },
            },
            gridProps: { xs: 12, sm: 6 },
          },
          {
            name: 'form.realized_margin',
            label: 'Realized Margin',
            itemType: 'textfield',
            jItemProps: {
              type: 'number',
              InputProps: {
                startAdornment: '%',
              },
            },
            gridProps: { xs: 12, sm: 6 },
          },
        ],
      },

      {
        name: 'custom-fields',
        itemType: 'typography',
        jItemProps: {
          variant: 'overline',
          sx: { mb: '0 !important', pb: '0 !important' },
        },
        label: 'Additional Fields',
      },
      {
        name: 'additional-fields-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        // precondition: (values: any) => !disable_type && values?.type === 'Default',
        name: 'form.custom_fields',
        itemType: 'fieldarray',
        label: 'Additional Field',
        gridProps: {
          // sx: { paddingTop: '10px !important' },
        },
        array: [
          {
            precondition: (values: any) =>
              !values?.form?.custom_fields?.[values.index]?.fieldtype,
            name: 'fieldtype',
            label: 'Type',
            // disabled: edit,
            itemType: 'autocomplete',
            options: ['Owner', 'Custom'],
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Custom',
            name: 'dynamic',
            label: 'Custom Field',
            jItemProps: {
              textFieldType: 'custom',
              // labelFunc: (name: any, values: any, formik: FormikHelpers<any>) => {
              //   return getIn(values, name) || 'Please enter the field label...'
              // },
              InputProps: {
                startAdornment: (
                  name: any,
                  values: any,
                  formik: FormikHelpers<any>
                ) => {
                  if (!getIn(values, name)?.value) {
                    return (
                      <InputAdornment position="end">
                        <Tooltip title={`Reset type`}>
                          <IconButton
                            onClick={() => {
                              formik.setFieldValue(name, undefined);
                              formik.setFieldValue(
                                name.replaceAll('dynamic', 'fieldtype'),
                                undefined
                              );
                            }}
                          >
                            <RestartAlt color="secondary" />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    );
                  }
                },
              },
            },
            itemType: 'textfield',
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Owner',
            name: 'owner_name',
            label: 'Owner',
            itemType: 'textfield',
          },
        ],
      },
    ],
  ];
};

export const useCustomProjectForm = ({
  id,
  edit = false,
  setPreview,
  setOpenContact,
}: {
  id?: number;
  edit?: boolean;
  setPreview?: Function;
  setOpenContact?: Function;
}): [any, JItem[]] => {
  const { data: templates = [] } = useGetProjectTemplatesQuery({});
  const [deleteProjectContact] = useDeleteProjectContactMutation();
  const [createProjectContact] = useCreateProjectContactMutation();
  const [editProjectContact] = useUpdateProjectContactMutation();
  const { data: roles = [] } = useGetRolesQuery({});
  const { data: teams = [] } = useGetTeamsQuery({});
  const { data: market_segments = [] } = useGetMarketSegmentsQuery({});
  const { data: subscribers = [] } = useGetSubscribersQuery({
    params: { nested: 'all' },
  });
  return [
    Yup.object({
      title: Yup.string().required('Project name is required'),
      type: Yup.object().nullable().required('Project type is required'),
    }),
    [
      {
        precondition: () => !edit,
        name: 'project-templates',
        label: 'Project Template',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'project-templates-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'template',
        label: 'Project Template',
        itemType: 'autocomplete',
        options: templates,
        gridProps: (values: any) =>
          !values?.template ? { xs: 12 } : { xs: 12, sm: 6 },
        jItemProps: {
          helperText: (values: any) => (
            <Typography variant="caption" id="tableTitle" component="div">
              <Tooltip title={`Preview Template`}>
                <IconButton
                  onClick={event => {
                    // event.stopPropagation()
                    // event.preventDefault()
                    setPreview && setPreview(values.id);
                  }}
                  size="small"
                >
                  <InfoOutlined color="secondary" />
                </IconButton>
              </Tooltip>{' '}
              Preview Template
            </Typography>
          ),
        },
      },
      {
        precondition: (values: any) => !edit && !!values?.template,
        name: 'assignees',
        multiple: true,
        label: 'Assign all template items (optional)',
        itemType: 'autocomplete',
        options: values => {
          return subscribers
            ?.filter(
              (s: Subscriber) =>
                !values?.assignees?.find((r: any) => s.contact_r?.id === r.id)
            )
            ?.map((subscriber: Subscriber) => ({
              id: subscriber?.contact_r.id,
              email: subscriber?.contact_r?.email,
              name: subscriber?.contact_r?.firstname
                ? `${subscriber?.contact_r?.firstname} ${subscriber?.contact_r?.lastname}`
                : subscriber?.contact_r?.email,
            }));
        },
        gridProps: { xs: 12, sm: 6 },
      },
      {
        precondition: () => !edit,
        name: 'internal-team-label',
        label: 'Project Team',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'internal-team-label-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'contacts',
        itemType: 'fieldarray',
        label: 'teammates',
        array: [
          {
            name: 'contact',
            label: 'Teammate',
            // freeSolo: true,
            itemType: 'autocomplete',
            options: values => {
              return subscribers
                ?.filter(
                  (s: Subscriber) =>
                    !values?.contacts?.find(
                      (r: any) => s.contact_r?.id === r.contact?.id
                    )
                )
                ?.map((subscriber: Subscriber) => ({
                  id: subscriber?.contact_r.id,
                  email: subscriber?.contact_r?.email,
                  name: subscriber?.contact_r?.firstname
                    ? `${subscriber?.contact_r?.firstname} ${subscriber?.contact_r?.lastname}`
                    : subscriber?.contact_r?.email,
                }));
            },
            gridProps: { xs: 12, sm: 6 },
          },
          {
            name: 'role',
            label: 'Role',
            itemType: 'autocomplete',
            // freeSolo: true,
            options: [
              ...(roles.filter(role => role.type === 'Internal') || []),
            ].sort((a, b) => sortString(a.name, b.name)),
            jItemProps: {
              getOptionLabel: (option: any) =>
                option?.name ? `${option.name}-${option.type}` : `Role`,
            },
            gridProps: { xs: 10, sm: 6 },
          },
        ],
        gridProps: { xs: 12 },
      },
      {
        name: 'project-details',
        label: 'Project Details',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-details-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'title',
        label: 'Project Name *',
        itemType: 'textfield',
        gridProps: { xs: 12 },
      },
      // {
      //   name: 'stage',
      //   label: 'Project Stage',
      //   itemType: 'autocomplete',
      //   options: stages,
      //   gridProps: { xs: 12, sm: 6 },
      // },
      {
        name: 'details',
        label: 'Project Description',
        itemType: 'textfield',
        jItemProps: { multiline: true, rows: 4, variant: 'outlined' },
        gridProps: { xs: 12 },
      },
      // {
      //   name: 'customer_name',
      //   label: 'Customer Name',
      //   itemType: 'textfield',
      //   gridProps: { xs: 12, sm: 6 },
      // },
      // {
      //   name: 'customer_number',
      //   label: 'Customer number',
      //   itemType: 'textfield',
      //   gridProps: { xs: 12, sm: 6 },
      // },
      // {
      //   name: 'job-location-label',
      //   label: 'Job Location',
      //   itemType: 'typography',
      //   jItemProps: { variant: 'overline' },
      // },
      // {
      //   name: 'job-location-label-bottom',
      //   label: '',
      //   itemType: 'divider',
      //   gridProps: { sx: { paddingTop: '0px !important' } },
      // },
      // {
      //   name: 'address',
      //   label: 'Street address',
      //   itemType: 'textfield',
      //   gridProps: { xs: 12, sm: 5 },
      // },
      // {
      //   name: 'city',
      //   label: 'Town/City',
      //   itemType: 'textfield',
      //   gridProps: { xs: 12, sm: 5 },
      // },
      // {
      //   name: 'zip',
      //   label: 'Zip code',
      //   itemType: 'textfield',
      //   gridProps: { xs: 12, sm: 2 },
      // },
      {
        name: 'project-dates',
        label: 'Project Dates',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-dates-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        name: 'due_date',
        label: 'Expected completion date',
        itemType: 'datepicker',
        gridProps: { xs: 12, sm: 6 },
      },
      // {
      //   name: 'install_date',
      //   label: 'Installation completion',
      //   itemType: 'datepicker',
      //   gridProps: { xs: 12, sm: 6 },
      // },
      {
        precondition: () => !edit,
        name: 'attachments-label',
        label: 'Attachments',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        precondition: () => !edit,
        name: 'attachments-label-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'attachments',
        label: 'Upload Documents / Drawings',
        itemType: 'dropzone',
        gridProps: { xs: 12 },
      },
      {
        name: 'custom-fields',
        itemType: 'typography',
        jItemProps: {
          variant: 'overline',
          sx: { mb: '0 !important', pb: '0 !important' },
        },
        label: 'Additional Fields',
      },
      {
        name: 'additional-fields-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        // precondition: (values: any) => !disable_type && values?.type === 'Default',
        name: 'form.custom_fields',
        itemType: 'fieldarray',
        label: 'Additional Field',
        gridProps: {
          // sx: { paddingTop: '10px !important' },
        },
        array: [
          {
            precondition: (values: any) =>
              !values?.form?.custom_fields?.[values.index]?.fieldtype,
            name: 'fieldtype',
            label: 'Type',
            // disabled: edit,
            jItemProps: edit ? { type: 'local-disabled' } : {},
            itemType: 'autocomplete',
            options: ['Owner', 'Custom'],
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Custom',
            name: 'dynamic',
            label: 'Custom Field',
            ...(!edit
              ? {
                  tooltip: {
                    title: (
                      <Typography variant="body1">
                        Please specify the title of the field
                      </Typography>
                    ),
                    open: true,
                    placement: 'top',
                    arrow: true,
                  },
                }
              : {}),
            jItemProps: {
              textFieldType: 'custom',
              // labelFunc: (name: any, values: any, formik: FormikHelpers<any>) => {
              //   return getIn(values, name)?.label || 'Please enter the field label...'
              // },
              InputProps: {
                startAdornment: (
                  name: any,
                  values: any,
                  formik: FormikHelpers<any>
                ) => {
                  return (
                    <InputAdornment position="end">
                      <Tooltip title={`Reset type`}>
                        <IconButton
                          onClick={() => {
                            formik.setFieldValue(name, undefined);
                            formik.setFieldValue(
                              name.replaceAll('dynamic', 'fieldtype'),
                              undefined
                            );
                          }}
                        >
                          <RestartAlt color="secondary" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  );
                },
              },
            },
            itemType: 'textfield',
          },
          {
            precondition: (values: any) =>
              values?.form?.custom_fields?.[values.index]?.fieldtype ===
              'Owner',
            name: 'owner_name',
            label: 'Owner',
            itemType: 'textfield',
          },
          // {
          //   precondition: (values: any) => values?.form?.custom_fields?.[values.index]?.fieldtype === "Custom",
          //   name: 'value',
          //   label: 'Value',
          //   itemType: 'textfield',
          // },
          // {
          //   precondition: (values: any) => values?.form?.custom_fields?.[values.index]?.fieldtype === "Team",
          //   name: 'team',
          //   label: 'Select a Team',
          //   // disabled: edit,
          //   jItemProps: edit ? { type: 'local-disabled' } : {
          //     InputProps: {
          //       startAdornment: (name: any, values: any, formik: FormikHelpers<any>) => {
          //         return (
          //           <Tooltip title={`Reset type`}>
          //             <IconButton
          //               onClick={() => formik.setFieldValue(name.replaceAll('team', 'fieldtype'), undefined)}
          //             >
          //               <RestartAlt color='secondary' />
          //             </IconButton>
          //           </Tooltip>
          //         )
          //       },
          //     },
          //   },
          //   itemType: 'autocomplete',
          //   options: teams,
          // },
          // {
          //   precondition: (values: any) =>
          //     values?.form?.custom_fields?.[values.index]?.fieldtype ===
          //     'Market Segment',
          //   name: 'market_segment',
          //   label: 'Market Segment',
          //   // disabled: edit,
          //   jItemProps: {
          //     type: edit ? 'local-disabled' : undefined,
          //     InputProps: {
          //       startAdornment: (
          //         name: any,
          //         values: any,
          //         formik: FormikHelpers<any>
          //       ) => {
          //         if (!getIn(values, name)) {
          //           return (
          //             <Tooltip title={`Reset type`}>
          //               <IconButton
          //                 onClick={() =>
          //                   formik.setFieldValue(
          //                     name.replaceAll('market_segment', 'fieldtype'),
          //                     undefined
          //                   )
          //                 }
          //               >
          //                 <RestartAlt color="secondary" />
          //               </IconButton>
          //             </Tooltip>
          //           );
          //         }
          //       },
          //     },
          //   },
          //   itemType: 'autocomplete',
          //   options: market_segments,
          // },
        ],
      },
      {
        precondition: () => !edit,
        name: 'submit',
        itemType: 'button',
        jItemProps: { type: 'submit' },
        label: 'CREATE PROJECT',
        gridProps: { xs: 12, sm: 6, md: 5, mx: 'auto' },
      },
    ],
  ];
};

export const useProjectTemplateForm = ({
  id,
  edit = false,
}: {
  id?: number;
  edit?: boolean;
}): [any, JItem[]] => {
  const { data: types = [] } = useGetProjectTypesQuery({});
  const { data: market_segments = [] } = useGetMarketSegmentsQuery({});
  return [
    Yup.object({
      title: Yup.string().required('Template title is required'),
      type: Yup.object().required('Please select a project type').nullable(),
    }),
    [
      {
        name: 'project-details',
        label: 'Template details',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
      },
      {
        name: 'project-details-bottom',
        label: '',
        itemType: 'divider',
        gridProps: { sx: { paddingTop: '0px !important' } },
      },
      {
        precondition: () => !edit,
        name: 'title',
        label: 'Template Title',
        itemType: 'textfield',
        gridProps: { xs: 12 },
      },
      {
        // precondition: () => !edit,
        name: 'type',
        label: 'Project Type *',
        itemType: 'autocomplete',
        options: types,
        gridProps: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0
            ? { xs: 12, sm: 6 }
            : { xs: 12 },
        jItemProps: {
          onChange: (value: any, name: string, setFieldValue: Function) => {
            setFieldValue('market_segment', null);
          },
        },
      },
      {
        precondition: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ).length > 0,
        name: 'market_segment',
        label: 'Market Segment',
        // disabled: edit,
        itemType: 'autocomplete',
        options: (values: any) =>
          market_segments?.filter(
            (ms: MarketSegment) => ms?.project_type === values?.type?.id
          ),
        gridProps: { xs: 12, sm: 6 },
      },
      {
        name: 'details',
        label: 'Template Details',
        itemType: 'textfield',
        jItemProps: { multiline: true, rows: 4, variant: 'outlined' },
        gridProps: { xs: 12 },
      },
      {
        precondition: () => !edit,
        name: 'submit',
        itemType: 'button',
        jItemProps: { type: 'submit' },
        label: 'CREATE TEMPLATE PROJECT',
        gridProps: { xs: 12, sm: 6, md: 5, mx: 'auto' },
      },
    ],
  ];
};

export const renderContactGroups = (role?: any, displayRole?: boolean) => ({
  // groupBy: (option: any) =>
  //   option?.groupBy?.toUpperCase() ||
  //   option?.organization_r?.name?.toUpperCase() ||
  //   ' ',
  renderGroup: (params: any) => {
    return (
      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}>
        {params?.group && (
          <Box
            sx={{
              px: 1,
              backgroundColor: 'lightgray',
              borderRadius: '2px',
            }}
          >
            {params?.group?.toUpperCase() !== role?.name?.toUpperCase() ? (
              <Tooltip
                title={`Organization: ${
                  typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()
                }`}
              >
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <CorporateFare
                    sx={{ fontSize: '12px', mr: 1 }}
                    color="secondary"
                  />
                  {typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()}
                </Box>
              </Tooltip>
            ) : (
              <Tooltip
                title={`Stakeholder: ${
                  typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()
                }`}
              >
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <Badge sx={{ fontSize: '12px', mr: 1 }} color="secondary" />
                  {typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()}
                </Box>
              </Tooltip>
            )}
          </Box>
        )}
        {params.children}
      </Box>
    );
  },
  renderOption: (props: any, option: any) => {
    return (
      <Box
        component="li"
        sx={{ whiteSpace: 'nowrap', fontSize: '1em' }}
        {...props}
      >
        {option?.addValue ? (
          <>
            <Tooltip title="Add Contact">
              <PersonAdd fontSize="inherit" sx={{ mr: 1 }} />
            </Tooltip>
            {option.title}
          </>
        ) : (
          <>
            {(option?.firstname || option?.lastname) && (
              <span>
                <Person
                  sx={{
                    fontSize: '12px',
                    mr: 1,
                  }}
                  color="secondary"
                />
                {`${option?.firstname || ''} ${option?.lastname || ''}`}
              </span>
            )}
            {option?.email && (
              <i>
                <u>
                  <Mail
                    sx={{
                      fontSize: '12px',
                      mr: 1,
                      ml: option?.firstname || option?.lastname ? 1 : 0,
                    }}
                    color="secondary"
                  />
                  <small>{option?.email}</small>
                </u>
              </i>
            )}
            {!option?.groupBy ? (
              <>
                {option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role}</small>
                  </i>
                )}
              </>
            ) : (
              <>
                {!!displayRole && option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role}</small>
                  </i>
                )}
                {option?.organization_r?.name && (
                  <b>
                    <CorporateFare
                      sx={{ fontSize: '12px', mx: 1 }}
                      color="secondary"
                    />

                    <small>{option?.organization_r?.name?.toUpperCase()}</small>
                  </b>
                )}
              </>
            )}
          </>
        )}
      </Box>
    );
  },
});

export const renderStakeholderContactGroups = (
  role?: any,
  displayRole?: boolean
) => ({
  groupBy: (option: any) => {
    return option?.group?.toUpperCase() || ' ';
  },
  renderGroup: (params: any) => {
    return (
      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}>
        {params?.group && (
          <Box
            sx={{
              px: 1,
              backgroundColor: theme => theme.palette.secondary.main,
              borderRadius: '2px',
            }}
          >
            {params?.group?.toUpperCase() !== role?.name?.toUpperCase() ? (
              params?.group?.toUpperCase() === 'PROJECT_CONTACT' ? (
                <Tooltip title={`PROJECT CONTACTS`}>
                  <Box
                    component={'span'}
                    sx={{ fontWeight: 600, color: 'white' }}
                  >
                    <FolderShared sx={{ fontSize: '12px', mr: 1 }} />
                    PROJECT CONTACTS
                  </Box>
                </Tooltip>
              ) : (
                <Tooltip title={`ALL CONTACTS`}>
                  <Box
                    component={'span'}
                    sx={{ fontWeight: 600, color: 'white' }}
                  >
                    <Contacts sx={{ fontSize: '12px', mr: 1 }} />
                    ALL CONTACTS
                  </Box>
                </Tooltip>
              )
            ) : (
              <Tooltip
                title={`Stakeholder: ${
                  typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()
                }`}
              >
                <Box
                  component={'span'}
                  sx={{ fontWeight: 600, color: 'white' }}
                >
                  <Badge sx={{ fontSize: '12px', mr: 1 }} />
                  {typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()}
                </Box>
              </Tooltip>
            )}
          </Box>
        )}
        {params.children}
      </Box>
    );
  },
  renderOption: (props: any, option: any) => {
    return (
      <Box
        component="li"
        sx={{ whiteSpace: 'nowrap', fontSize: '1em' }}
        {...props}
      >
        {option?.addValue ? (
          <>
            <Tooltip title="Add Contact">
              <Add fontSize="inherit" sx={{ mr: 1 }} />
            </Tooltip>
            {option.title}
          </>
        ) : option?.type === 'organization' ? (
          <Box
            sx={{
              px: 1,
              // backgroundColor: 'lightgray',
              border: '2px solid lightgray',
              borderRadius: '2px',
            }}
          >
            {option.groupBy?.toUpperCase() !== role?.name?.toUpperCase() ? (
              <Tooltip title={`Organization: ${option?.name}`}>
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <CorporateFare
                    sx={{ fontSize: '12px', mr: 1 }}
                    color="secondary"
                  />
                  {option?.name}
                </Box>
              </Tooltip>
            ) : (
              <Tooltip
                title={`Stakeholder: ${
                  typeof option.groupBy === 'string'
                    ? option.groupBy?.toUpperCase()
                    : option.groupBy?.name?.toUpperCase()
                }`}
              >
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <Badge sx={{ fontSize: '12px', mr: 1 }} color="secondary" />
                  {option?.name}
                </Box>
              </Tooltip>
            )}
          </Box>
        ) : (
          <>
            {option.organization_r?.name && (
              <span>
                <KeyboardReturn
                  sx={{
                    fontSize: '12px',
                    mx: 1,
                    transform: 'scale(-1,1)',
                  }}
                  color="secondary"
                />
              </span>
            )}
            {(option.contact_r?.firstname ||
              option.contact_r?.lastname ||
              option.name) && (
              <span>
                <Person
                  sx={{
                    fontSize: '12px',
                    mr: 1,
                  }}
                  color="secondary"
                />
                {`${option?.name || ''} ${option.contact_r?.firstname || ''} ${
                  option.contact_r?.lastname || ''
                }`}
              </span>
            )}
            {option.contact_r?.email && (
              <i>
                <u>
                  <Mail
                    sx={{
                      fontSize: '12px',
                      mr: 1,
                      ml:
                        option.contact_r?.firstname ||
                        option.contact_r?.lastname
                          ? 1
                          : 0,
                    }}
                    color="secondary"
                  />
                  <small>{option.contact_r?.email}</small>
                </u>
              </i>
            )}
            {!option?.groupBy ? (
              <>
                {option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role_r?.name}</small>
                  </i>
                )}
              </>
            ) : (
              <>
                {!!displayRole && option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role_r?.name}</small>
                  </i>
                )}
                {option?.organization_r?.name && (
                  <b>
                    <CorporateFare
                      sx={{ fontSize: '12px', mx: 1 }}
                      color="secondary"
                    />

                    <small>{option?.organization_r?.name?.toUpperCase()}</small>
                  </b>
                )}
              </>
            )}
          </>
        )}
      </Box>
    );
  },
});
